import { FirebaseReducer, FirebaseSaga, LanguageReducer, StatsReducer } from '@web_opxp/features';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { AuthReducer, AuthSaga } from '../../../auth';
import appReducer from './reducer';
import rootSaga from './saga';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (...funcs: any[]) => any;
  }
}

function getStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const sagaMiddleware = createSagaMiddleware();
  const languageMiddleware = createSagaMiddleware();
  const firebaseMiddleware = createSagaMiddleware();
  const authMiddleware = createSagaMiddleware();
  const reducer = combineReducers({
    app: appReducer,
    [StatsReducer.statePropName]: StatsReducer.featureReducer,
    [LanguageReducer.statePropName]: LanguageReducer.default,
    [FirebaseReducer.statePropName]: FirebaseReducer.default,
    [AuthReducer.statePropName]: AuthReducer.featureReducer,
  });
  const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, languageMiddleware, firebaseMiddleware, authMiddleware))
  );
  sagaMiddleware.run(rootSaga);
  firebaseMiddleware.run(FirebaseSaga);
  authMiddleware.run(AuthSaga);
  return store;
}

export default getStore;
